import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import CenterPage from "./components/centerPage";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";

export default function LockUpCenter() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  return (
    <div
      className="min-h-screen bg-neutral-900 w-full"
    >
    <AcendexLayout 
    theme="light"
    pcTopBarTitle={translate(getText("鎖倉挖礦"))}
    mobileTopBarTitle={translate(getText("鎖倉挖礦"))}
    hideBottomBar
    >
    <div className="container mx-auto">

      <CenterPage />
    </div>
    </AcendexLayout>

    </div>
  );
}
